import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			ads: {},
			adPosConfig: {
				detailInsert: [1, 2],
			},
			adsensConfig: {},
			domainConfig: {},
			categories: [],
			recommendList: [],
			// 品牌列表数据
			brandList: [{ label: 'All', value: 'all' }],
			// 品牌列表是否已加载
			brandListLoaded: false,
			// 车辆列表页状态
			carListState: {
				// 是否从详情页返回
				fromDetail: false,
				// 当前页码
				currentPage: 1,
				// 筛选条件
				filters: {
					purpose: 'all',
					brand: 'all',
					type: 'all',
					price: 'all',
					fuel: 'all',
				},
				// 最近访问页面路径
				lastVisitedPage: '',
				// 查询参数
				queryParams: {},
			},
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			SET_CATEGORIES(state, categories) {
				state.categories = categories
			},
			SET_RECOMMEND_LIST(state, list) {
				state.recommendList = list
			},
			// 设置品牌列表
			SET_BRAND_LIST(state, brandList) {
				state.brandList = brandList
			},
			// 设置品牌列表加载状态
			SET_BRAND_LIST_LOADED(state, loaded) {
				state.brandListLoaded = loaded
			},
			// 设置列表页状态
			SET_CAR_LIST_STATE(state, { fromDetail, currentPage, filters, lastVisitedPage, queryParams }) {
				state.carListState = {
					fromDetail: fromDetail !== undefined ? fromDetail : state.carListState.fromDetail,
					currentPage: currentPage || state.carListState.currentPage,
					filters: filters || state.carListState.filters,
					lastVisitedPage: lastVisitedPage || state.carListState.lastVisitedPage,
					queryParams: queryParams || state.carListState.queryParams,
				}
			},
			// 设置来源页面是否为详情页
			SET_FROM_DETAIL(state, fromDetail) {
				state.carListState.fromDetail = fromDetail
			},
			// 设置当前页码
			SET_CURRENT_PAGE(state, page) {
				state.carListState.currentPage = page
			},
			// 设置筛选条件
			SET_FILTERS(state, filters) {
				state.carListState.filters = { ...state.carListState.filters, ...filters }
			},
			// 设置最近访问页面
			SET_LAST_VISITED_PAGE(state, page) {
				state.carListState.lastVisitedPage = page
			},
			// 设置查询参数
			SET_QUERY_PARAMS(state, params) {
				state.carListState.queryParams = params
			},
			// 重置列表页状态
			RESET_CAR_LIST_STATE(state) {
				state.carListState = {
					fromDetail: false,
					currentPage: 1,
					filters: {
						purpose: 'all',
						brand: 'all',
						type: 'all',
						price: 'all',
						fuel: 'all',
					},
					lastVisitedPage: '',
					queryParams: {},
				}
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			// 获取品牌列表
			brandList: (state) => state.brandList,
			// 品牌列表是否已加载
			brandListLoaded: (state) => state.brandListLoaded,
			// 车辆列表状态
			carListState: (state) => state.carListState,
			isFromDetail: (state) => state.carListState.fromDetail,
			currentPage: (state) => state.carListState.currentPage,
			filters: (state) => state.carListState.filters,
			lastVisitedPage: (state) => state.carListState.lastVisitedPage,
			queryParams: (state) => state.carListState.queryParams,
		},
	})
}
